'use client'

import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { ORDER_STATUS } from 'my-purchases/constants/orderStatus'
import type { OrderDetails } from 'my-purchases/types/purchaseDetail'
import { sendOnClickOrderTracking } from 'my-purchases/utils/analytics/analyticsEvents'
import { useMemo } from 'react'

import text from 'fukku/styles/texts.module.scss'

interface OrderTrackingNumberProps {
	readonly order: OrderDetails
	readonly className?: string
}

export function OrderTrackingNumber({
	order,
	className,
}: OrderTrackingNumberProps) {
	const { t } = useLabels()
	const { shippings, active, status } = order

	const { trackingUrl = '', trackingNumber } = shippings?.[0] ?? {}

	const placeholderValues = {
		Tracking: trackingUrl ?? '',
	}

	const labelConfigTrackingUrl = {
		className: text.bodyMRegularUnderline,
		target: '_blank',
	}

	const renderTrackingWithUrl = useMemo(() => {
		if (trackingNumber) {
			if (trackingUrl) {
				return (
					<a
						href={trackingUrl}
						target='_blank'
						rel='noopener noreferrer'
						onClick={sendOnClickOrderTracking}
						className={text.bodyM}
					>
						{trackingNumber}
					</a>
				)
			}

			return <span className={text.bodyM}>{trackingNumber}</span>
		}

		return (
			<ClientLabel
				linkProps={labelConfigTrackingUrl}
				placeholderValues={placeholderValues}
			>
				{t('myPurchases.tracking.text.trackOrder')}
			</ClientLabel>
		)
	}, [trackingNumber, trackingUrl, labelConfigTrackingUrl, placeholderValues])

	if (
		!active ||
		status === ORDER_STATUS.delivered ||
		(!trackingUrl && !trackingNumber)
	) {
		return null
	}

	return (
		<div className={className}>
			<h2>{t('myPurchases.online.details.tracking.title')}</h2>
			<span>{trackingUrl ? renderTrackingWithUrl : trackingNumber}</span>
		</div>
	)
}
